import '@mrhenry/wp--bugsnag-config';

import './modules/mr-banner-highlighter';
import './modules/mr-carousel';
import './modules/mr-offer-overlay';
import './modules/mr-video';
import './modules/mr-video-responsive';
import './modules/navigation/mr-navigation-overlay';

import { MrAccordion, MrDisplayValue, MrInputSink, MrPlayPauseToggle } from '@mrhenry/wp--mr-interactive';

window.customElements.define( 'mr-accordion', MrAccordion );
window.customElements.define( 'mr-display-value', MrDisplayValue );
window.customElements.define( 'mr-input-sink', MrInputSink );
window.customElements.define( 'mr-play-pause-toggle', MrPlayPauseToggle );
